import React from 'react';
import { PacmanLoader} from 'react-spinners';
import './loader.css'

export const Loader = () => {

    return (
        <div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100vh'}}>
          <div id="loading-wrapper">
            <div id="loading-text">LOADING</div>
            <div id="loading-content"></div>
           </div>
        </div>
    );
}

